// блокировка скролла на странице
export const pageScrollLock = (status = false) => {
  const body = document.querySelector('body');
  status ? body.classList.add('is-scroll-lock') : body.classList.remove('is-scroll-lock');
};

// добавляет свойство subdomainLink в зависимости от домена (тестовый или нет)
export const addressesLinkHadle = addresses => {
  const arr = [];
  const domain = window.location.hostname.split('.')[window.location.hostname.split('.').length - 2];
  const subdomain = window.location.hostname.split('.')[0];

  addresses.forEach(address => {
    let subdomainLink;
    let subdomainLink_en;
    if (address.id === 44618) {
      subdomainLink = '//seafoodbastards.ru';
      subdomainLink_en = '//seafoodbastards.ru';
    } else if (domain === 'keep-calm' || subdomain === 'test') {
      subdomainLink = `//${address.testLink}` || '';
      subdomainLink_en = `//${address.testLink}/en` || '';
    } else {
      subdomainLink = `//${address.link}` || '';
      subdomainLink_en = `//${address.link}/en` || '';
    }
    arr.push({ ...address, subdomainLink, subdomainLink_en });
  });
  return arr;
};

// генерит pathname для переключения между городами
export const selectPath = activeLanguage => {
  let path;
  if (window.location.pathname.split('/')[2] === 'menu' || window.location.pathname.split('/')[1] === 'menu') {
    activeLanguage === 1 ? (path = '/menu') : (path = '/en/menu');
  } else if (window.location.pathname.split('/')[2] === 'beer' || window.location.pathname.split('/')[1] === 'beer') {
    activeLanguage === 1 ? (path = '/beer') : (path = '/en/beer');
  } else if (
    window.location.pathname.split('/')[2] === 'events' ||
    window.location.pathname.split('/')[1] === 'events'
  ) {
    activeLanguage === 1 ? (path = '/events') : (path = '/en/events');
  } else if (
    window.location.pathname.split('/')[2] === 'articles' ||
    window.location.pathname.split('/')[1] === 'articles'
  ) {
    activeLanguage === 1 ? (path = '/articles') : (path = '/en/articles');
  } else if (window.location.pathname.split('/')[2] === 'about' || window.location.pathname.split('/')[1] === 'about') {
    activeLanguage === 1 ? (path = '/about') : (path = '/en/about');
  } else {
    path = window.location.pathname;
  }
  return path;
};

// генерит название свойства (testLink/stageLink/link) из /api/addresses или из cities для использования на тестовом сайте, stage и прод
export const selectLink = () => {
  const subdomain = window.location.hostname.split('.')[0];
  const domain = window.location.hostname.split('.')[window.location.hostname.split('.').length - 2];
  const stage = window.location.hostname.split('.')[window.location.hostname.split('.').length - 3];
  if (domain === 'keep-calm' || subdomain === 'test') {
    return 'testLink';
  }
  if (stage === 'stage') {
    return 'stageLink';
  }
  return 'link';
};
